import type ApplicationInstance from "@ember/application/instance";
import { getOwner } from "@ember/owner";
import Service from "@ember/service";
import type CoreAdapter from "parog-web/adapters/core";

export default class ExternalMedicAuthService extends Service {
  applicationAdapter = (getOwner(this) as ApplicationInstance).lookup(
    "adapter:application"
  ) as CoreAdapter;

  async generateMagicLink() {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", "/api/v1/magic_link", true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.onload = function () {
        if (this.readyState === 4 && this.status === 201) {
          resolve(JSON.parse(this.responseText).data?.attributes?.link);
        } else {
          reject(new Error(xhr.statusText));
        }
      };

      for (const key in this.applicationAdapter.headers) {
        if (this.applicationAdapter.headers.hasOwnProperty(key)) {
          xhr.setRequestHeader(key, this.applicationAdapter.headers[key]);
        }
      }
      xhr.send();
    });
  }
}
